/**
 * The Marketing tab, which is now two lists.
 *
 * It was one: what the advertising earned and what is owed for it (ADR 0074).
 * The neighbour letters joined it because they are the other marketing thing
 * this company does — twenty households hear about a roof at signing and again
 * when it is finished (ADR 0149) — and because the person who prints them
 * needs somewhere to go that is not Tools.
 *
 * A switch rather than a tenth tab across the top. The top nav is nine items
 * on a phone already, and "which of our advertising is working" and "what have
 * I got to post" are two questions the same person asks in the same place.
 */

import type { Job } from "@roof-hawk/core";

import { useRememberedState } from "../../lib/hooks";
import { MarketingReport } from "./MarketingReport";
import { NeighbourMailingList } from "./NeighbourMailingList";

const VIEWS = [
  ["advertising", "Advertising"],
  ["neighbours", "Neighbour letters"],
] as const;

type View = (typeof VIEWS)[number][0];

export function MarketingScreen({ jobs }: { jobs: readonly Job[] }) {
  // Remembered for the tab, so a refresh on Neighbour letters stays there
  // rather than dropping back to Advertising. Anything this screen does not
  // recognise (a view since removed) falls back to the first.
  const [remembered, setView] = useRememberedState("marketing", "advertising");
  const view: View =
    VIEWS.find(([value]) => value === remembered)?.[0] ?? "advertising";

  return (
    <>
      <div className="viewswitch" role="tablist" aria-label="Marketing">
        {VIEWS.map(([value, label]) => (
          <button
            key={value}
            type="button"
            role="tab"
            aria-selected={view === value}
            className={view === value ? "on" : ""}
            onClick={() => setView(value)}
          >
            {label}
          </button>
        ))}
      </div>
      {view === "advertising" ? (
        <MarketingReport jobs={jobs} />
      ) : (
        <NeighbourMailingList />
      )}
    </>
  );
}
